import React from 'react';
import Type from '../Shared/Type';
import picture from '../../assets/My Pic 1.png'
import { Link } from 'react-router-dom';
import { Fade } from 'react-reveal';
const Banner = () => {
    return (

        <div class="hero min-h-screen bg-[#1f1f38]">
            <div class="hero-content flex-col lg:flex-row-reverse">
                <div class="text-center lg:text-right">
                    <Fade right>
                        <img src={picture} class=" rounded-lg w-full pl-24" alt='' />
                    </Fade>
                </div>
                <Fade left>
                    <div class=" flex flex-col justify-start items-center lg:w-1/2 ">
                        <div class="text-left">
                            <h1 class=" text-white font-bold mb-2 lg:text-xl  sm:text-lg">I'm <br /><span className=' text-5xl font-bold font-sanns'> Kaniz Fatema</span></h1>
                            <Type></Type>
                            <Link to='/Resume/Resume of KF.pdf ' target='_blank' download class="btn w-1/2 leading-5  mt-5 bg-[#4db5ff] ">Download Resume</Link>
                        </div>
                    </div>
                </Fade>
            </div>
        </div>



    );
};

export default Banner;